"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const styles_1 = require("../styles");
const Text_1 = __importDefault(require("./Text"));
const TextBase_1 = __importDefault(require("./TextBase"));
const TextAreaInput = ({ onChangeText, value, placeholder, onSubmitEditing, numberOfLines, iconComponent, editable = true, label, style, textInputStyle, }) => {
    const [isFocused, setIsFocused] = react_1.useState(false);
    const [inputHeight, setInputHeight] = react_1.useState(20);
    const hasLabel = (isFocused || value) && label;
    return (react_1.default.createElement(react_native_1.View, { style: react_native_1.StyleSheet.flatten([styles.container, { minHeight: 37 }, style]) },
        !!hasLabel && react_1.default.createElement(Text_1.default, { style: styles.label },
            label,
            ":"),
        react_1.default.createElement(react_native_1.View, { style: react_native_1.StyleSheet.flatten([
                styles.inputContainer,
                {
                    height: inputHeight + 15,
                },
            ]) },
            react_1.default.createElement(react_native_1.TextInput, { multiline: true, onChangeText: (text) => {
                    if (onChangeText)
                        onChangeText(text);
                }, onFocus: () => setIsFocused(true), onBlur: () => setIsFocused(false), editable: editable, numberOfLines: numberOfLines, placeholder: !isFocused ? placeholder : '', placeholderTextColor: styles_1.Colors.darkGray, value: value, autoCapitalize: "none", onSubmitEditing: onSubmitEditing, style: react_native_1.StyleSheet.flatten([
                    styles.textInput,
                    !editable && { color: styles_1.Colors.black },
                    react_native_1.Platform.select({
                        native: {
                            textAlign: 'right',
                        },
                        web: {
                            textAlign: 'left',
                            height: inputHeight,
                        },
                    }),
                    textInputStyle,
                ]) }),
            react_1.default.createElement(TextBase_1.default, { onLayout: (e) => {
                    const height = e.nativeEvent.layout.height;
                    setInputHeight(height);
                }, style: styles.textBaseStyle }, value)),
        iconComponent && react_1.default.createElement(react_native_1.View, { style: styles.icon }, iconComponent)));
};
exports.default = TextAreaInput;
const styles = react_native_1.StyleSheet.create({
    container: {
        backgroundColor: styles_1.Colors.background,
        // alignItems: 'center',
        borderRadius: styles_1.getRadius(),
        marginBottom: styles_1.getSpacing(),
        // paddingHorizontal: getSpacing(),
        overflow: 'hidden',
        flexDirection: 'row',
    },
    inputContainer: {
        minHeight: 40,
        maxHeight: 150,
        flex: 1,
    },
    label: {
        color: styles_1.Colors.darkGray,
        marginTop: 8,
        paddingRight: styles_1.getSpacing(),
    },
    icon: {
        marginLeft: styles_1.getSpacing(),
    },
    textInput: {
        paddingHorizontal: styles_1.getSpacing(),
        fontFamily: 'IranYekan-FD-Regular',
        color: styles_1.Colors.primary,
        flex: 1,
        fontSize: 12,
        fontWeight: '400',
    },
    textBaseStyle: {
        ...react_native_1.Platform.select({
            web: {
                wordWrap: 'break-word',
            },
        }),
        fontFamily: 'IranYekan-FD-Regular',
        flex: 1,
        fontSize: 12,
        fontWeight: '400',
        position: 'absolute',
        zIndex: -10,
        opacity: 0,
    },
});
